/* eslint-disable jsx-a11y/anchor-is-valid */
import {useKTable} from '../../../../../../../../contexts/KTableProvider'

import {useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  InputDateWrapper,
  InputTextWrapper,
  SelectAsyncWrapper,
  SelectWrapper,
} from '../../../../../../../../components/UI/Form/Input'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {
  ERROR_MESSAGE_SYSTEM,
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_DELETE,
} from '../../../../../../../../util/Constants'
import {confirmModal, ShowSnackBar} from '../../../../../../../../util/functions'
import {useCollaborator, useTableMaster} from '../../../../../../hooks'
import {Reception} from '../../../../../../model'
import {
  createReceptionLaundryOperation,
  deleteReceptionByLaundryOperation,
  getOrderOperationReception,
} from '../../../../../../services'
export const FormReception = ({
  setDetailPrint,
  setShowModalPrint,
  setFirstLoad,
  getDataById,
  minLength,
  setMinLength,
  setShowModalNew,
  setDataHead,
  idReception,
}: any) => {
  const {data, setLoading, selectedOn} = useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const {deliveryLocation, getDeliveryLocationList} = useTableMaster()
  const {getUserCollaboratorData} = useCollaborator()
  const methods = useFormContext()
  const {setValue, handleSubmit, setError, watch} = methods
  const getOrderPrint = async () => {
    try {
      const response = await getOrderOperationReception(currentTabItem.idToEdit)
      const data = response.data.data

      setDetailPrint(data)
      setShowModalPrint(true)
    } catch (error) {}
  }

  useEffect(() => {
    getDeliveryLocationList()
  }, [])

  useEffect(() => {
    if (!idReception) {
      if (deliveryLocation.length > 0) {
        let getValue = deliveryLocation.filter((item) => item.codigo === 'EN HABITACIÓN')
        setValue('lugarRecepcion', getValue[0].value as string)
      }
    }
  }, [deliveryLocation, idReception])

  const handleDelete = async () => {
    let title = '¿Estás seguro?'
    let bodyText = 'Al eliminar no podrás revertir esta acción'
    let textButtonCancel = 'No'
    let textButtonConfirm = 'Si, eliminar'
    try {
      const result = await confirmModal({
        title,
        bodyText,
        icon: 'warning',
        textButtonCancel,
        textButtonConfirm,
      })

      if (result.isConfirmed) {
        setLoading(true)
        const {data: response} = await deleteReceptionByLaundryOperation(selectedOn[0])
        if (!response.error) {
          ShowSnackBar(SUCCESS_MESSAGE_DELETE)
          getDataById()
          setFirstLoad(false)
        } else {
          ShowSnackBar(response.message, 'error')
        }
      }
    } catch (error) {
      console.error('Error al eliminar:', error)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleNew = () => {
    setShowModalNew(true)
  }
  const handleGetName = (e: any) => {
    setValue('responsable', e.label)
    setValue('responsableId', e.value)
    setError('responsableId', {})
  }
  const handleGetDateReception = (e: any) => {
    let value = e.target.value
    setMinLength(value)
  }

  const onSubmitReception = async () => {
    getOrderPrint()
  }
  const onSubmit = async (dataInfo: Reception) => {
    setDataHead(null)
    let title = '¿Estás seguro?'
    let bodyText = 'Al finalizar la recepción no podrás revertir esta acción'
    let textButtonCancel = 'No'
    let textButtonConfirm = 'Si, finalizar'
    try {
      const result = await confirmModal({
        title,
        bodyText,
        icon: 'warning',
        textButtonCancel,
        textButtonConfirm,
      })

      if (result.isConfirmed) {
        setLoading(true)
        let obj = {
          detalle: data,
          id: idReception,
          ordenId: currentTabItem.idToEdit,
          lugarRecepcion: dataInfo.lugarRecepcion,
          responsable: dataInfo.responsable,
          responsableId: dataInfo.responsableId,
          fechaRecepcion: dataInfo.fechaRecepcion,
          fechaProgramada: dataInfo.fechaProgramada,
        }
        const {data: response} = await createReceptionLaundryOperation(obj)
        if (!response.error) {
          ShowSnackBar(SUCCESS_MESSAGE_CREATE)
          getDataById()
          getOrderPrint()
          setFirstLoad(false)
        } else {
          ShowSnackBar(response.message, 'error')
        }
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }
  const loadOptions = async (inputValue: string, callback: (options: any[]) => void) => {
    if (inputValue.length < 3) {
      callback([])
      return
    }
    try {
      const response = await getUserCollaboratorData({
        siteId: watch('siteId') || '',
        buscaTexto: inputValue,
      })

      const mappedGuests = response.map((guest) => ({
        value: guest.usuarioId,
        label: `${guest.nombres} ${guest.materno} ${guest.paterno}`,
      }))
      callback(mappedGuests)
    } catch (error) {
      console.error('Error fetching options:', error)
      callback([])
    }
  }
  return (
    <form>
      {isAllowed('RECEPCION/FINALIZAR_RECEPCION') && (
        <div className='row'>
          <div className='mb-2 col-3'>
            <SelectWrapper
              labelText='Lugar de recepción'
              name='lugarRecepcion'
              data={deliveryLocation}
              disabled={idReception}
              required
            />
          </div>
          <div className='mb-2 col-3'>
            <SelectAsyncWrapper
              labelText='Colaborador'
              name='responsableId'
              loadOptions={loadOptions}
              onChangeValue={handleGetName}
              value={
                watch('responsableId')
                  ? {
                      value: watch('responsableId') || '',
                      label: watch('responsable') || '',
                    }
                  : null
              }
              disabled={idReception}
              required
            />
          </div>
          <div className='col-sm-12 col-lg-3'>
            <InputDateWrapper
              labelText='Fecha de recepción'
              name='fechaRecepcion'
              onChange={handleGetDateReception}
              readOnly={idReception}
            />
          </div>
          <div className='col-sm-12 col-lg-3'>
            <InputDateWrapper
              labelText='Fecha programada'
              name='fechaProgramada'
              minValue={minLength}
              readOnly={idReception}
            />
          </div>
        </div>
      )}
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper labelText='Cantidad Total' name='cantidadTotal' disabled={true} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper labelText='Peso Total' name='pesoTotal' disabled={true} />
        </div>
        {!idReception ? (
          <div className='col-sm-12 col-lg-6 d-flex justify-content-end align-items-end'>
            <div className='d-flex justify-content-end'>
              {isAllowed('RECEPCION/FINALIZAR_RECEPCION') && (
                <button
                  type='button'
                  className='btn btn-primary me-3'
                  disabled={data.length < 1}
                  onClick={handleSubmit(onSubmit)}
                >
                  Finalizar Recepción
                </button>
              )}
              {isAllowed('RECEPCION/AGREGAR') && (
                <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                  Agregar
                </button>
              )}
              {isAllowed('RECEPCION/ELIMINAR') && (
                <button
                  type='button'
                  className='btn btn-primary me-3'
                  disabled={selectedOn.length < 1}
                  onClick={handleDelete}
                >
                  Eliminar
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className='col-sm-12 col-lg-6 d-flex justify-content-end align-items-end'>
            <div className='d-flex justify-content-end'>
              {isAllowed('RECEPCION/REIMPRIMIR') && (
                <button
                  type='button'
                  className='btn btn-success me-3'
                  onClick={handleSubmit(onSubmitReception)}
                >
                  Re-imprimir
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </form>
  )
}
